import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import './header.scss';
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const drawerWidth = 240;
const navItems = [''];

function Header(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(prevState => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant='h6' sx={{ my: 2 }}>
        MUI
      </Typography>
      <Divider />
      <List>
        {navItems.map(item => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar sx={{ backgroundColor: '#005984' }} component='nav'>
       <Grid display={'flex'} alignItems={'center'} container>
      <Grid item xs={3}>
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          <div className='logo_container'>
            <div>
              <svg
                className='logo'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 262 116'
              >
                <path
                  d='M101.735,115.737a10.369,10.369,0,1,0-.126,0Zm0-17.454a7.023,7.023,0,1,1-6.94,7.105h0v-.04a6.982,6.982,0,0,1,6.94-7.024h0Zm47.334.353V95.228h-11.2v20.218h11.2v-3.408h-7.626v-5.88h7.4v-3.429h-7.4V98.636h7.626m-15.5-3.408H130v13.423L117.838,95.187h-2.451v20.259h3.574v-13.34l12.2,13.319h2.41v-20.2M251.456,78.131a5.237,5.237,0,1,1,5.238,5.236h0a5.186,5.186,0,0,1-5.236-5.136Zm.838,0a4.4,4.4,0,1,0,4.4-4.4,4.4,4.4,0,0,0-4.4,4.4Zm6.7,3.142h-1.047l-1.466-2.723h-.838v2.723h-.838V75.408h2.514c1.047,0,2.094.209,2.094,1.466a1.431,1.431,0,0,1-1.4,1.466h-.28Zm-3.351-5.237V77.5h.838c.838,0,1.885.21,1.885-.628s-.628-.838-1.257-.838ZM249.571,48.6l-7.96,14.034L233.652,48.6h-5.865L239.1,68.286V83.158h5.027V68.286L255.436,48.6ZM213.963,70.171h8.588c-.419,5.237-5.865,9.007-10.473,9.007a13.3,13.3,0,0,1-12.568-13.2,12.746,12.746,0,0,1,23.041-7.959l.209.419,3.561-3.352-.21-.209a17.877,17.877,0,1,0-27.98,22.259c.04.051.082.1.123.153A18.548,18.548,0,0,0,211.659,84,16.093,16.093,0,0,0,228,68.286V65.563H213.963Zm-22.2-11.52a9.915,9.915,0,0,0-4.608-8.378,19.18,19.18,0,0,0-9.006-1.676H172.7V82.948h5.027V68.705h1.047l9.845,14.243H194.9L184.22,68.286a9.341,9.341,0,0,0,7.54-9.635Zm-4.817.21c0,3.979-2.723,5.655-8.378,5.655h-.838V53.205h.628c5.862,0,8.585,1.885,8.585,5.656Zm-37.7,24.3H168.1V78.34H154.267V66.61h13.406V61.793H154.267V53.415h13.825V48.6H149.24ZM139.6,48.6V72.9L117.612,48.6H114.47V83.158h5.03v-24.3l21.994,24.3h3.351V48.6ZM91.43,83.158h19.061V78.34H96.457V66.61h13.615V61.793H96.457V53.415h14.034V48.6H91.43Zm105.776-48.8H183.382V22.624h13.405V18.016h-13.4V9.428h13.824V4.611h-19.06V39.172h19.06ZM160.551,20.32l15.71-15.709h-6.913L155.734,18.645V4.611h-5.027V39.172h5.027V24.928l1.256-1.256,12.568,15.5h6.7Zm-19.479,4.608c0,6.912-2.514,10.054-7.75,10.054s-7.75-3.351-7.75-10.054V4.611h-5.027V26.4c0,7.959,5.027,13.4,12.777,13.4,7.54,0,12.777-5.446,12.777-13.4V4.611h-5.027ZM98.552,4.611H91.221V39.172h7.331c11.939,0,19.479-6.7,19.479-17.385C117.822,11.314,110.281,4.611,98.552,4.611Zm-2.3,4.817H97.3c7.121,0,15.5,2.095,15.5,12.568s-8.379,12.567-15.5,12.567H96.248Zm-44.828,64.3A11.91,11.91,0,0,1,44.3,77.5c-4.189.21-8.169-2.3-9.426-11.52L18.12,60.955C25.451,86.928,45.768,86.09,52.68,74.57q.628-.942,0-1.257C52.261,73.1,51.843,73.313,51.424,73.732Zm0-68.493C44.721-8.375,20.633,5.03,16.654,39.8a3.522,3.522,0,0,0,1.885,3.98,19.271,19.271,0,0,0,6.912,2.3,17.22,17.22,0,0,0,5.655.419,3.4,3.4,0,0,0,3.352-3.142C37.809,6.077,46.187-2.092,50.167,5.868,50.8,6.706,51.843,6.287,51.424,5.239Zm-4.19,11.73a4.11,4.11,0,0,0-4.189,1.885,13.931,13.931,0,0,0-1.885,5.655,21.224,21.224,0,0,0-.419,6.284,2.514,2.514,0,0,0,2.514,1.885c7.54.419,29.952,3.561,33.094,10.264,2.095,4.4-4.189,5.655-8.8,6.912a3.558,3.558,0,0,0-2.933,2.932,9.32,9.32,0,0,0,1.257,6.7,2.06,2.06,0,0,0,2.829.7c.035-.021.07-.044.1-.067l.209-.209A32,32,0,0,0,75.3,54.252C90.173,33.307,58.755,17.178,47.234,16.969Zm7.75,34.142C17.491,55.3-12.252,38.124,10.37,33.935c0,0,2.932-.628,3.351-2.3a39.7,39.7,0,0,0,1.257-4.4,32.664,32.664,0,0,1,1.047-3.351c.838-1.885-.419-2.932-2.932-1.676C-7.434,32.259-1.36,50.9,15.187,60.327A52.128,52.128,0,0,0,51.424,66.4a8.344,8.344,0,0,0,5.027-3.351,12.606,12.606,0,0,0,2.094-8.588,3.043,3.043,0,0,0-2.932-3.142A.773.773,0,0,0,54.984,51.111Z'
                  fill='#fff'
                />
              </svg>
            </div>
          </div>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map(item => (
              <Button key={item} sx={{ color: '#fff' }}>
                {item}
              </Button>
            ))}
          </Box>
        </Toolbar>
        </Grid>
        <Grid item xs={6}>
        <Box className="middle_container" display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <Typography variant='h5'>HEALTH DASHBOARD</Typography>
        </Box>
        </Grid>
        <Grid item xs={3}>
          <Box display={'flex'} alignItems={'center'} justifyContent={'end'} marginRight={2}>
<PersonIcon sx={{ fontSize: '40px'}}/>
          
<Typography marginLeft={1}>Dhruv</Typography>
          </Box>
        </Grid>
       </Grid>

      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

export default Header;
